import type { Market } from "#types";

export function isFinnishMarket(): boolean {
  return getTargetMarket() === "fi";
}

export function isSwedishMarket(): boolean {
  return getTargetMarket() === "se";
}

export function getTargetMarket(): Market {
  return (window as any).TARGET_MARKET;
}
